import { render, staticRenderFns } from "./TopRanks.vue?vue&type=template&id=27dbe5c6&scoped=true&"
import script from "./TopRanks.vue?vue&type=script&lang=js&"
export * from "./TopRanks.vue?vue&type=script&lang=js&"
import style0 from "./TopRanks.vue?vue&type=style&index=0&id=27dbe5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dbe5c6",
  null
  
)

export default component.exports